import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

/**
 * Returns `t` and `lang` for use in workbook components.
 * If the workbook has a `languageLock` field, `lang` is fixed to that value.
 * Otherwise `lang` tracks the current i18next language.
 *
 * @param {object} [workbook] - The workbook object, optionally containing a `languageLock` string.
 */
const useLockedTranslate = (workbook) => {
  const { t } = useTranslation();
  const languageLock = workbook?.languageLock;

  const getActiveLang = () =>
    languageLock ?? i18next.language.split('-')[0] ?? 'en';

  const [lang, setLang] = useState(getActiveLang);

  useEffect(() => {
    setLang(getActiveLang());
  }, [t, languageLock]);

  return { t, lang };
};

export default useLockedTranslate;
